import { render, staticRenderFns } from "./LetterTextWithExamplesCard.vue?vue&type=template&id=60b293f7"
import script from "./LetterTextWithExamplesCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./LetterTextWithExamplesCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports